// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-page-tag-___page-tag__page-tag___gvTKU {
  background: var(--gray-light);
  border-radius: 5px;
  color: white;
  margin-right: 0.5em;
  padding: 0.15em 0.4em;
}

.src-components-page-tag-___page-tag__prefix___IkcQI {
  opacity: 0.75;
}
`, "",{"version":3,"sources":["webpack://./src/components/page-tag/page-tag.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".page-tag {\n  background: var(--gray-light);\n  border-radius: 5px;\n  color: white;\n  margin-right: 0.5em;\n  padding: 0.15em 0.4em;\n}\n\n.prefix {\n  opacity: 0.75;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-tag": `src-components-page-tag-___page-tag__page-tag___gvTKU`,
	"pageTag": `src-components-page-tag-___page-tag__page-tag___gvTKU`,
	"prefix": `src-components-page-tag-___page-tag__prefix___IkcQI`
};
export default ___CSS_LOADER_EXPORT___;
